import { Emitter } from "@welshman/lib";
export class Echo extends Emitter {
    get connections() {
        return [];
    }
    async send(...payload) {
        this.emit(...payload);
    }
    cleanup = () => {
        this.removeAllListeners();
    };
}
//# sourceMappingURL=Echo.js.map